import {Breadcrumbs, Link, Stack, Typography} from "@mui/material";
import {Link as RouterLink, Navigate, useNavigate} from "react-router-dom";
import * as React from "react";
import {appSession} from "../../Broadtask";
import ProcessManagerPane from "../../components/process/ProcessManagerPane";
import {sectionTitle} from "../../../AppStyles";

const ProcessManager = () =>
{
    const navigate = useNavigate();

    function onCreate()
    {
        navigate("/processes/create");
    }

    function onView()
    {
        navigate("/processes/DEMO_PROCESS");
    }

    return <Stack spacing={1}padding={1}>
        <Stack direction="row"
               sx={sectionTitle}
               alignItems="center" justifyContent="space-between" padding={1}>
            <Breadcrumbs>
                <Link component={RouterLink} to={"/"} underline={"hover"}>Home</Link>
                <Typography>Processes</Typography>
            </Breadcrumbs>
        </Stack>

        {
            appSession.activeSession() === false ?
            <Navigate to="/login"/> :
            <Stack direction="column" justifyContent="flex-start" alignItems="stretch"
                   spacing={2}
                   padding={1}>

                <ProcessManagerPane />

            </Stack>
        }
    </Stack>
};

export default ProcessManager;
